import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

function Main({ activeIndex }) {
    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>
                    <ListGroup>

                        <ListGroup.Item as={Link} action to="/admissions" className={`p-3 ${activeIndex==0 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Admissions
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/btech" className={`p-3 ${activeIndex==1 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            B.Tech
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/mtech" className={`p-3 ${activeIndex==2 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.Tech
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/msc" className={`p-3 ${activeIndex==3 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.Sc
                        </ListGroup.Item>
            

                        <ListGroup.Item as={Link} action to="/ms" className={`p-3 ${activeIndex==4 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.S (Research)
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/phd" className={`p-3 ${activeIndex==5 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Ph.D
                        </ListGroup.Item>


                        <ListGroup.Item as={Link} action to="/master-of-public-policy-mpp" className={`p-3 ${activeIndex==6 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Master of Public Policy (MPP)
                        </ListGroup.Item>


                        <ListGroup.Item as={Link} action to="/academic-calender" className={`p-3 ${activeIndex==7 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Academic Calendar
                        </ListGroup.Item>
                        


                        <ListGroup.Item as={Link} action to="/b-tech-curriculum" className={`p-3 ${activeIndex==8 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Curriculum
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/minors" className={`p-3 ${activeIndex==15 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Minors
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/btechtimetable" className={`p-3 ${activeIndex==9 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            TimeTable[B.Tech]
                        </ListGroup.Item>


                        <ListGroup.Item as={Link} action to="/timetable-pg" className={`p-3 ${activeIndex==10 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            TimeTable[PG]
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/statement-of-expenditure" className={`p-3 ${activeIndex==11 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Statement of Expenditure
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/fee-structure" className={`p-3 ${activeIndex==12 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Fee Structure
                        </ListGroup.Item>


                        <ListGroup.Item as={Link} action to="/syllabus" className={`p-3 ${activeIndex==13 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Syllabus
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/ordinances" className={`p-3 ${activeIndex==14 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Ordinances
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/guidelines-honours-programme" className={`p-3 ${activeIndex==16 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Honours Programme
                        </ListGroup.Item>       

                    </ListGroup>
                </Col>
                {/* <Col sm={8}>
          <Tab.Content>
            <Tab.Pane eventKey="#link1">Tab pane content 1</Tab.Pane>
            <Tab.Pane eventKey="#link2">Tab pane content 2</Tab.Pane>
          </Tab.Content>
        </Col> */}
            </Row>
        </Tab.Container>
    );
}

export default Main;